import { render, staticRenderFns } from "./event.vue.html?vue&type=template&id=d6663cd8"
import script from "./event.ts?vue&type=script&lang=js&external"
export * from "./event.ts?vue&type=script&lang=js&external"
import style0 from "./event.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports